import { SelectNormalIcons } from "../SetupWidget/SelectWidgetIcon";
import MultiSelectBtn from "./multiSelectBtn";
import { useGetDevice } from "../../../api/userInfo";
import { useEffect, useState } from "react";
import { InputWithLabel } from "src/components/ui/inputFields/input-with-label";
/*
setup fields for single field widget (don't have multiple fields)
- Total Value Widget
- Current Status Widget
- Performance Device Listed
*/

export const SingleFieldSetup = ({clearForm, submitForm, widgetDetails, updateSetupDetails, setupDetails, selectedWidget,updateWidgetTitle}) => {
    const {deviceList, isLoadingDeviceList, isErrorDeviceList} = useGetDevice(localStorage.getItem('plantId'));
    const [multiSelect,setMultiSelect ]= useState({})

    const [selectedField, setSelectedField]= useState('')

    //console.log(widgetDetails)
    useEffect(() => {
        if(multiSelect?.deviceFields?.length>0){
            document.getElementById('selectField').removeAttribute('disabled')
        }else{
            document.getElementById('selectField').setAttribute('disabled', true)
        }
        if(multiSelect?.data){
            updateSetupDetails({
                ...setupDetails,
                'measurement': [{
                    ...setupDetails.measurement?.[0],
                    [multiSelect?.field]: multiSelect?.data.length > 1 ? multiSelect?.data : multiSelect?.data[0],
                  }]
            });
        }
    }, [multiSelect]);

    // update setup details with widgetDetails.setup data 
    useEffect(() => {
        if(widgetDetails){
            updateSetupDetails(widgetDetails?.setup)
            setSelectedField(widgetDetails?.setup?.measurement?.[0]?.field)
        }
    }, []);
    

        //TODO: to refactor with new template of setup fields
    const onInputTitle = (field) => (e) => {
        updateWidgetTitle(e.target.value)
    }
    const onInput = (field) => (e) => {
                updateSetupDetails({
                    ...setupDetails,
                    'measurement': [{
                    ...setupDetails.measurement?.[0],
                    [field]: e.target.value
                    }]
                });
            
            if(field === 'field'){
                setSelectedField(e.target.value)
            }
    };

    const deviceDetails =widgetDetails?.setup?.measurement?.[0]?.device
    
    return ( 
        <>
            <div className="flex flex-col gap-4 mt-4">
                    <div className="flex flex-col gap-2">
                        <label htmlFor="device" className="col-span-1 text-sm text-gray-500">Device ID (select one or more devices)</label>
                        {/* <input onChange={onInput('device')} autoComplete="off" required type="text" name="device"  className="setupModal_input" placeholder={'1122'}/> */}
                        <MultiSelectBtn 
                        deviceDetail = {deviceDetails}
                        setMultiSelect={setMultiSelect} 
                        data={deviceList?.devices} 
                        name="device" 
                        placeholder="select device" 
                        />

                    </div> 
                
                    <div className={`grid ${(selectedWidget == 'Performance Widget' ||selectedWidget==='Gas Widget')  ? "xl:grid-cols-8 ":"xl:grid-cols-10"} gap-2 grid-cols-1`}>
                        {selectedWidget !== 'Performance Widget' && 
                            <InputWithLabel label="Title" placeholder="Title of widget" name="title" required 
                            onChange={onInputTitle('title')} 
                            defaultValue={widgetDetails?.title}
                            />
                        }
                        {selectedWidget !== 'Gas Widget' &&
                            <InputWithLabel label="Unit" placeholder="kWh" name="unit" required 
                            onChange={onInput('unit')} 
                            defaultValue={widgetDetails?.setup?.measurement?.[0]?.unit}
                        className={`${selectedWidget === 'Performance Widget' ? "col-span-4 ":"col-span-2 "}`}
                            />
                        }
                            

                        <div  className="flex flex-col col-span-4 gap-2">
                            <label htmlFor="field" className="col-span-1 text-sm text-gray-500"> Select Field</label>
                            <select id="selectField" className="setupModal_input" onChange={onInput('field')} disabled value={selectedField}>
                                {multiSelect?.deviceFields?.length ===undefined && <option>You need to first select the device/s</option>}
                                {multiSelect?.deviceFields?.length !==undefined && <option value={''}>{multiSelect?.info}</option>}
                                {multiSelect?.deviceFields?.map(({name, field}, index) => (
                                    <option key={index+field} value={field} >{name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
            </div>
                
                {selectedWidget !== 'Performance Widget' &&  selectedWidget !== 'Gas Widget' &&
                    <SelectNormalIcons updateSetupDetails={updateSetupDetails} setupDetails={setupDetails} defaultIcon={widgetDetails?.setup?.icon}/> 
                }

                
                {/* ------------ submit button */}
                <div className='flex flex-row justify-between gap-4 mt-4'>
                <button  type="button" onClick={()=> clearForm()} className='w-1/2 py-2 text-center border border-gray-300 rounded-md text-vekin hover:shadow-md'>
                    Cancel
                </button>

                
                    <button type="button" onClick={()=> submitForm()}  className='w-1/2 py-2 text-center text-white rounded-md bg-vekin hover:shadow-md'>
                        Submit
                    </button>  

                
                </div>
        </>
     );
}


 

